import "picturefill"
import Viewer from "@/components/viewer/viewer.js"

let shuffle = (list) => {
    for (let i = list.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        ;[list[i], list[j]] = [list[j], list[i]]
    }
    return list
}

// Page Œuvres : nouveau tirage à chaque visite (même si la page sort du cache),
// au moins une œuvre par rubrique, sans doublon, puis complété au hasard.
let drawMosaic = ($list) => {
    let count = parseInt($list.dataset.tirage, 10) || 9
    let items = shuffle([...$list.children])
    let picks = []
    let seen = new Set()

    for (let $item of items) {
        if (picks.length < count && !seen.has($item.dataset.rubrique)) {
            seen.add($item.dataset.rubrique)
            picks.push($item)
        }
    }

    for (let $item of items) {
        if (picks.length < count && !picks.includes($item)) picks.push($item)
    }

    for (let $item of items) $item.hidden = true

    for (let $item of shuffle(picks)) {
        $item.hidden = false
        $list.appendChild($item)
    }
}

let init = () => {
    for (let $list of document.querySelectorAll(".-js-mosaic")) drawMosaic($list)

    Viewer.init()
}

export default { init }
